/**
 * Local-only App Lock PIN lifecycle for Remote Settings.
 * Never implies a device command. PIN remains write-only.
 */

export const PIN_REQUIRED_MESSAGE = "PIN is required";
export const PIN_PATTERN_MESSAGE = "PIN must be a numeric value max 4 digits";
export const PIN_PATTERN = /^\d{1,4}$/;

export function isPinRequired(
  appLock: boolean,
  confirmedPinSet: boolean
): boolean {
  return appLock === true && confirmedPinSet !== true;
}

export function isPinInputEnabled(
  appLock: boolean,
  allowLocalPin: boolean
): boolean {
  return appLock === true && allowLocalPin;
}

export function isValidLocalPin(value: string | null | undefined): boolean {
  return typeof value === "string" && PIN_PATTERN.test(value);
}

export type LocalPinLifecycle = {
  /** null = clear unsent PIN; undefined = leave current value */
  appLockPin: null | undefined;
  clearErrors: boolean;
  runValidation: boolean;
};

/** App Lock OFF clears unsent PIN + errors. App Lock ON re-validates. */
export function localPinLifecycleOnAppLockChange(
  appLockEnabled: boolean
): LocalPinLifecycle {
  if (appLockEnabled) {
    return { appLockPin: undefined, clearErrors: false, runValidation: true };
  }
  return { appLockPin: null, clearErrors: true, runValidation: false };
}
